import { render, staticRenderFns } from "./RateChallengesTable.vue?vue&type=template&id=4e88c45f&scoped=true&"
import script from "./RateChallengesTable.vue?vue&type=script&lang=ts&"
export * from "./RateChallengesTable.vue?vue&type=script&lang=ts&"
import style0 from "./RateChallengesTable.vue?vue&type=style&index=0&id=4e88c45f&prod&lang=scss&scoped=true&"
import style1 from "./RateChallengesTable.vue?vue&type=style&index=1&id=4e88c45f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88c45f",
  null
  
)

export default component.exports